module.exports = __webpack_public_path__ + "img/your_multi.0556c148.jpg";